import React from 'react';
import shave from 'shave';
import { PropTypes } from 'prop-types';

class Shave extends React.Component {
    static defaultProps = {
        className: 'message'
    };

    componentDidMount() {
        const isElementTooLarge = this._element && this._element.clientHeight < this._element.scrollHeight;

        if (isElementTooLarge && this._element.children.length) {
            this.setShaveHeight();
            this.shaveContent();
        }
    }

    setShaveHeight = () => {
        this.shaveHeight = this._element.clientHeight - this.getElementMarginAndPaddingHeight(this._element);
    };

    shaveContent = () => {
        let childrenHeights = 0;
        let isShaved = false;
        for (const paragraph of this._element.children) {
            const paragraphHeight = paragraph.getBoundingClientRect().height +
                this.getElementMarginAndPaddingHeight(paragraph);
            const computedStyle = window.getComputedStyle(paragraph);
            const lineHeight = this.getComputedStyleProperty(computedStyle, 'line-height');
            const isParagraphOverflowing = (childrenHeights + paragraphHeight) > this.shaveHeight;

            if (isShaved) {
                paragraph.style.display = 'none';
            } else if (isParagraphOverflowing) {
                const remainingContentHeight = this.shaveHeight - childrenHeights || 1;

                if (remainingContentHeight < lineHeight) {
                    paragraph.style.display = 'none';
                } else {
                    const shownHeight = Math.floor(
                        remainingContentHeight / lineHeight
                    ) * lineHeight;
                    shave(paragraph, shownHeight, {
                        spaces: false
                    });
                }

                isShaved = true;
            } else {
                childrenHeights += paragraphHeight;
            }
        }
    };

    getComputedStyleProperty = (computedStyle, property) => {
        return parseFloat(computedStyle.getPropertyValue(property));
    };

    getElementMarginAndPaddingHeight = (element) => {
        const computedStyle = window.getComputedStyle(element);
        return this.getComputedStyleProperty(computedStyle, 'margin-top') +
            this.getComputedStyleProperty(computedStyle, 'margin-bottom') +
            this.getComputedStyleProperty(computedStyle, 'padding-top') +
            this.getComputedStyleProperty(computedStyle, 'padding-bottom');
    };

    render() {
        return (
            <div className={this.props.className} ref={e => this._element = e}>
                {this.props.children}
            </div>
        );
    }
}

export default Shave;

Shave.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};



// WEBPACK FOOTER //
// ./components/shave/index.jsx